import React from 'react'
import TuneOutlinedIcon from '@material-ui/icons/TuneOutlined';
import ChannelRow from './ChannelRow';
import VideoRow from './VideoRow';
import './SearchPage.css';

function SearchPage() {
    return (
        <div className="searchPage__wrapper">
            <div className="searchPage">
                <div className="searchPage__filter">
                    <TuneOutlinedIcon />
                    <div className="filter__title">
                        <h2>FILTER</h2>
                    </div>
                </div>
                <hr className="hr1" />

                <ChannelRow 
                    image="https://images.unsplash.com/photo-1518806118471-f28b20a1d79d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80"
                    channel="Newly Gamer"
                    verified
                    subs="697K"
                    noOfVideos={382}
                    description="You can find awasome Gaming Videos like tips and trick, Gliches, Game walkthrough and many more so please Subscribe."
                />

                <hr className="hr2" />

                <div className="latest">
                    <h4>Latest from Newly Gamer</h4>
                </div>

                <VideoRow
                    views="1.4M"
                    subs="659K"
                    description="You can find awasome Gaming Videos like tips and trick, Gliches, Game walkthrough and many more so please Subscribe"
                    timestamp="59 seconds ago"
                    channel="Newly Gamer"
                    title="Watch Dogs Legions Walkthrough - Part 1 || Newly Gamer"
                    image="https://4.bp.blogspot.com/-PWIzSXkbb7U/XX7rhnb7WaI/AAAAAAAANi0/GG5wD4dfA20RxXPTP4PQ0LuThg3JH0gEACLcBGAsYHQ/w914-h514-p-k-no-nu/watch-dogs-legion-mask-characters-uhdpaper.com-4K-5.612-wp.thumbnail.jpg"
                />

                <VideoRow
                    views="2.5M"
                    subs="659K"
                    description="You can find awasome Gaming Videos like tips and trick, Gliches, Game walkthrough and many more so please Subscribe"
                    timestamp="1 day ago"
                    channel="Newly Gamer"
                    title="Watch Dogs Legions Walkthrough - Part 2 || Newly Gamer"
                    image="https://4.bp.blogspot.com/-PWIzSXkbb7U/XX7rhnb7WaI/AAAAAAAANi0/GG5wD4dfA20RxXPTP4PQ0LuThg3JH0gEACLcBGAsYHQ/w914-h514-p-k-no-nu/watch-dogs-legion-mask-characters-uhdpaper.com-4K-5.612-wp.thumbnail.jpg"
                />

                <VideoRow
                    views="2.9M"
                    subs="659K"
                    description="You can find awasome Gaming Videos like tips and trick, Gliches, Game walkthrough and many more so please Subscribe"
                    timestamp="2 day ago"
                    channel="Newly Gamer"
                    title="Watch Dogs Legions Walkthrough - Part 3 || Newly Gamer"
                    image="https://4.bp.blogspot.com/-PWIzSXkbb7U/XX7rhnb7WaI/AAAAAAAANi0/GG5wD4dfA20RxXPTP4PQ0LuThg3JH0gEACLcBGAsYHQ/w914-h514-p-k-no-nu/watch-dogs-legion-mask-characters-uhdpaper.com-4K-5.612-wp.thumbnail.jpg"
                />

                <VideoRow
                    views="3M"
                    subs="659K"
                    description="You can find awasome Gaming Videos like tips and trick, Gliches, Game walkthrough and many more so please Subscribe"
                    timestamp="3 day ago"
                    channel="Newly Gamer"
                    title="Watch Dogs Legions Walkthrough - Part 4 || Newly Gamer"
                    image="https://4.bp.blogspot.com/-PWIzSXkbb7U/XX7rhnb7WaI/AAAAAAAANi0/GG5wD4dfA20RxXPTP4PQ0LuThg3JH0gEACLcBGAsYHQ/w914-h514-p-k-no-nu/watch-dogs-legion-mask-characters-uhdpaper.com-4K-5.612-wp.thumbnail.jpg"
                />

                <VideoRow
                    views="3.1M"
                    subs="659K"
                    description="You can find awasome Gaming Videos like tips and trick, Gliches, Game walkthrough and many more so please Subscribe"
                    timestamp="4 day ago"
                    channel="Newly Gamer"
                    title="Watch Dogs Legions Walkthrough - Part 5 || Newly Gamer"
                    image="https://4.bp.blogspot.com/-PWIzSXkbb7U/XX7rhnb7WaI/AAAAAAAANi0/GG5wD4dfA20RxXPTP4PQ0LuThg3JH0gEACLcBGAsYHQ/w914-h514-p-k-no-nu/watch-dogs-legion-mask-characters-uhdpaper.com-4K-5.612-wp.thumbnail.jpg"
                />

                <VideoRow
                    views="3.5M"
                    subs="659K"
                    description="You can find awasome Gaming Videos like tips and trick, Gliches, Game walkthrough and many more so please Subscribe"
                    timestamp="5 day ago"
                    channel="Newly Gamer"
                    title="Watch Dogs Legions Walkthrough - Part 6 || Newly Gamer"
                    image="https://4.bp.blogspot.com/-PWIzSXkbb7U/XX7rhnb7WaI/AAAAAAAANi0/GG5wD4dfA20RxXPTP4PQ0LuThg3JH0gEACLcBGAsYHQ/w914-h514-p-k-no-nu/watch-dogs-legion-mask-characters-uhdpaper.com-4K-5.612-wp.thumbnail.jpg"
                />

            </div>
        </div>
    )
}

export default SearchPage